// Kenney 1-Bit Pack tile frame indices.
//
// The spritesheet has 49 columns × 22 rows of 16×16 tiles (1078 total), packed
// with 0px spacing. Frame index = row * 49 + col. Open /inspect.html in a
// browser to see every tile labeled — clicking a tile copies its index.
//
// These initial picks are best guesses from the preview thumbnail. If anything
// looks wrong in-game, open the inspector, find the right index, and change
// the number here. No code anywhere else needs to know.
//
// LICENSE: CC0 (kenney.nl). Credited on the homepage; license text bundled at
// /assets/KENNEY_LICENSE.txt.

export const SPRITESHEET_KEY = "kenney-1bit";
export const SPRITESHEET_PATH = "/assets/tiles.png";
export const SPRITESHEET_TILE = 16; // each frame is 16×16
export const SPRITESHEET_COLS = 49;
export const SPRITESHEET_ROWS = 22;

/** Convenience helper: SPRITE(col, row) → frame index. */
export const SPRITE = (col: number, row: number): number =>
  row * SPRITESHEET_COLS + col;

/**
 * All tile picks live here. Each entry is a frame index (0-based) into the
 * tilesheet. If a sprite looks wrong, change the number — that's the entire
 * fix. Multi-frame entries (decorations) let us scatter variety.
 */
export const SPRITE_FRAMES = {
  // Sparse ground decorations — scattered across the arena floor for texture.
  // Top-left of sheet is vegetation: grass tufts, small plants.
  decorations: [SPRITE(0, 0), SPRITE(1, 0), SPRITE(2, 0), SPRITE(0, 1)],

  // The two combatants. Mid-sheet character row — small creature sprites.
  // Swap these freely; they don't have to be the same row.
  player1: SPRITE(36, 4), // warrior — leftmost guess at character region
  player2: SPRITE(40, 4), // mage — another distinct character

  // Fire tile placed on the arena floor (damages on step).
  fireTile: SPRITE(12, 12),

  // Projectile spawned by the fire-blast attack.
  projectile: SPRITE(12, 12),
} as const;

/** Background color used as the canvas/arena base — matches Kenney's sample sheets. */
export const ARENA_BG_COLOR = "#3a2129";
export const ARENA_BG_COLOR_NUM = 0x3a2129;
